// projects/humanresources-personnel/src/assets/i18n/*/hr-per-movement-service-status.json
export class HrPerMovementServiceStatusKey {
    private static readonly keyPrefix = 'hrPerMovementServiceStatus';
    public static title = `${HrPerMovementServiceStatusKey.keyPrefix}.title`;
    public static pageHeader = `${HrPerMovementServiceStatusKey.keyPrefix}.pageHeader`;
    public static serviceStatus = `${HrPerMovementServiceStatusKey.keyPrefix}.serviceStatus`;
    public static suspensionType = `${HrPerMovementServiceStatusKey.keyPrefix}.suspensionType`;
}
